<template>
  <v-card min-width="20vw" align="center" justify="center" light outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action><v-icon class="icon" @click="close" icon>fa-times</v-icon></v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <p v-html="$t('description')"/>
      <v-text-field v-model="confirmText" :placeholder="$t('confirmPlaceholder')" outlined/>
      <v-btn :disabled="!passCheck" @click="abandonTest">{{ $t('btnAbandon') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../../repositories/funding';
export default {
  name: "AbandonTest",
  data() {
    return {
      passCheck: false,
      confirmText: '',
    };
  },
  watch: {
    confirmText() {
      let toCheck = (this.$i18n.locale === 'en')? 'CONFIRM' : 'CONFIRMAR';
      this.confirmText = this.confirmText.toUpperCase();
      this.passCheck = (this.confirmText === toCheck);
    },
  },
  methods: {
    abandonTest() {
      Repository.abandonFundingTest(this.$store.state.fundingTest.id).then((response) => {
        if(response.status < 400) {
         alert(this.$t('alerts.successfulAbandoned'));
         this.close();
         this.$router.push({ name: 'funding-simulation-home' });
        }
        else
          alert(this.$t('alerts.error'));
      });
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>

<i18n>
{
  "en":{
    "title": "Abandon your Simulation",
    "description": "Write <b>CONFIRM</b> to let you abandon the evaluation.",
    "confirmPlaceholder": "CONFIRM",
    "alerts": {
      "successfulAbandoned": "The funding evaluation was successfully abandoned.",
      "error": "An error occurred.\nPlease try again."
    },
    "btnAbandon": "Abandon"
  },
  "es": {
    "title": "Abandona tu Simulación",
    "description": "Escribe <b>CONFIRMAR</b> para que puedas abandonar la prueba.",
    "confirmPlaceholder": "CONFIRMAR",
    "alerts": {
      "successfulAbandoned": "La prueba de fondeo fue abandonada satisfactoriamente.",
      "error": "Un error ocurrió.\nIntente de nuevo."
    },
    "btnAbandon": "Abandonar"
  }
}
</i18n>

<style scoped>

</style>
